import { Box } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '../../../Common/Typography'
import { IUser } from '../../../User/DataStore/IUser'
import { BaseAbsenceCard } from '../../layout/AbsenceFormBase/components/BaseAbsenceCard'
import { IAbsenceNew } from '../IAbsenceNew'

interface IProps {
  isRefetching: boolean
  absences: IAbsenceNew[]
  person: IUser
}

export const AbsenceList = ({ isRefetching, absences, person }: IProps) => {
  const { t } = useTranslation()

  const filteredAbsences = absences.filter(
    absence => absence.person.uuid === person.uuid,
  )

  if (filteredAbsences.length === 0) {
    return (
      <Box m={3} p={2}>
        <Text>{`${t('There are no absences for')} ${person.firstName} ${
          person.lastName ?? ''
        }`}</Text>
      </Box>
    )
  }
  return (
    <Box m={3} p={2}>
      {filteredAbsences.map(absence => (
        <BaseAbsenceCard
          key={absence.uuid}
          absenceInfo={absence}
          isRefetching={isRefetching}
          pageType={'absence'}
        />
      ))}
    </Box>
  )
}
